<template>
  <div class="login-container">
    <div class="login-form">
      <button type="button" class="close-button" @click="router.push('/daily')">&times;</button>
      <h2>Logging in...</h2>
      <p v-if="error" class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { authService } from '../services/auth'

const router = useRouter()
const emit = defineEmits(['auth-changed'])
const error = ref('')

const handleLogin = async () => {
  try {
    error.value = ''
    await authService.login()
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'An error occurred during login'
  }
}

onMounted(() => {
  handleLogin()
})
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-form {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  position: relative;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  color: #dc3545;
  border: none;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
}

.close-button:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.login-button:hover {
  background-color: #f8f8f8;
}

.google-icon {
  width: 24px;
  height: 24px;
}

.error {
  color: #dc3545;
  margin-top: 1rem;
  text-align: center;
}
</style>
